import types from './mutation-types';

export default {
	toggleEditMode: (state, payload) => {
		// console.log('toggleEditModes', state, payload);
		state.flagEditMode = !state.flagEditMode;
		// console.log('toggleEditModes', state, payload);
	},
	delete: (state, payload) => {
		// console.log('DELETE', state, payload)
	},
	toggleWidgetSideBar: (state, payload) => {
		state.widgetSideBar = payload === undefined ? !state.widgetSideBar : payload;
	},
	setRefGridLayout: (state, payload) => {
		state.refGridLayout = payload;
	},
	[types.SET_WIDGET_ITEMS]: (state, payload) => {
		state.widgetItems = payload;
	},
	[types.SET]: (state, { key, value }) => {
		state[key] = value;
	},
	clearDisplayCoachMarkFlag(state) {
		state.displayCoachMarkFlag = false;
	}
};
